export class AgentRegisterFields {
    constructor(
        public name: any,
        public email: string
    ) {

    }
}
